import React, { useEffect, useState } from "react";
import { Typography, Stack, Button, Grid } from "@mui/material";
import * as shpwrite from "@mapbox/shp-write";
import config from "../config";

function Downloader(props) {
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        if (!props.features) return;
        if (props.features.length > 20) {
            setShowError(true);
        } else {
            setShowError("");
        }
    }, [props.features]);

    const getData = (callback) => {
        const ids = props.features
            .map((el) => el.properties.feldblockidentnummer)
            .join(",");

        if (!props.features) return;
        fetch(config.backendOrigin + "api/fid?fid=" + ids, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                if (!res.ok) {
                    return false;
                } else {
                    return res.json();
                }
            })
            .then((data) => {
                if (typeof callback === "function") {
                    callback(data);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const downloadGeoJSON = () => {
        getData((data) => {
            const geoJSON = {
                type: "FeatureCollection",
                features: data,
            };
            const blob = new Blob([JSON.stringify(geoJSON)], {
                type: "application/json",
            });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "flik.geojson";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    };

    const downloadShapefile = async () => {
        getData((data) => {
            const geoJSON = {
                type: "FeatureCollection",
                features: data,
            };

            const options = {
                folder: "flik",
                filename: "flik",
                outputType: "blob",
                compression: "DEFLATE",
                types: {
                    polygon: "flik",
                },
            };

            shpwrite.download(geoJSON, options);
        });
    };

    return (
        <>
            <Stack
                spacing={1}
                // sx={{
                //     marginTop: "10px",
                // }}
            >
                <Typography variant="body1">Fläche Herunterladen</Typography>
                {showError && (
                    <Typography>
                        Maximal 20 Flächen dürfen für den Download ausgewählt
                        sein.
                    </Typography>
                )}
                <Grid container>
                    <Grid item size={5}>
                        <Button
                            disabled={showError ? true : false}
                            variant="contained"
                            onClick={downloadGeoJSON}
                        >
                            GeoJSON
                        </Button>
                    </Grid>
                    <Grid item size={1}></Grid>
                    <Grid item size={5}>
                        <Button
                            disabled={showError ? true : false}
                            variant="contained"
                            onClick={downloadShapefile}
                        >
                            Shapefile
                        </Button>
                    </Grid>
                </Grid>
            </Stack>
        </>
    );
}

export default Downloader;
